module.exports = __webpack_public_path__ + "app stores.svg?f14405e8fbd5495374c88a34cd426b6b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/app stores.svg
// module id = 352
// module chunks = 0